export default __webpack_public_path__ + "static/media/healthscore.01fa9eb2.gif";